import { render } from "./PreviewCanvas.vue?vue&type=template&id=6a1bafc0"
import script from "./PreviewCanvas.vue?vue&type=script&lang=js"
export * from "./PreviewCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__